/**
 * websiteAnalyticsService.js
 *
 * Frontend service for the portal company Website Analytics page.
 * Wrappers for the three GA4 account analytics callable functions.
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * List GA4 properties accessible to the connected Google account for this company.
 * Returns { ok, properties: [{ propertyId, displayName, accountName }] }
 *       or { ok: false, needsOAuth, message }
 */
export async function listGa4PropertiesForAccount() {
  const fn = httpsCallable(functions, 'listGa4PropertiesForAccount', { timeout: 30000 });
  const result = await fn();
  return result.data;
}

/**
 * Save the user's chosen GA4 property for their company.
 * @param {string} propertyId - numeric property ID string
 * @param {string} [propertyDisplayName]
 */
export async function setGa4PropertyForAccount(propertyId, propertyDisplayName = '') {
  const fn = httpsCallable(functions, 'setGa4PropertyForAccount', { timeout: 15000 });
  const result = await fn({ propertyId, propertyDisplayName });
  return result.data;
}

/**
 * Fetch GA4 report data for the account's selected property.
 * Returns { ok, overview, sources, events, pages, propertyId, propertyDisplayName }
 *       or { ok: false, needsOAuth | needsPropertyPicker | configError, message }
 */
export async function fetchAccountWebsiteAnalytics({ startDate = '30daysAgo', endDate = 'today' } = {}) {
  const fn = httpsCallable(functions, 'getAccountWebsiteAnalytics', { timeout: 30000 });
  const result = await fn({ startDate, endDate });
  return result.data;
}
